export enum ROIMetricDisplayType {
  RENTAL_INCOME,
  EQUITY,
}
